import React, { useState } from 'react';
import apiClient from '../services/apiClient';

const PROVIDER_LABELS = { google: 'Google', outlook: 'Outlook', icloud: 'iCloud' };
const PROVIDER_COLORS = { google: '#4285f4', outlook: '#0078d4', icloud: '#1c1c1e' };

const CalendarDisconnectModal = ({ provider, onClose, onSuccess }) => {
  const [isDisconnecting, setIsDisconnecting] = useState(false);
  const [error, setError] = useState('');

  const providerLabel = PROVIDER_LABELS[provider] || 'Calendar';
  const providerColor = PROVIDER_COLORS[provider] || '#555';

  const handleDisconnect = async () => {
    setIsDisconnecting(true);
    setError('');
    try {
      await apiClient.delete('/api/calendar/auth');
      setIsDisconnecting(false);
      onSuccess();
    } catch (e) {
      console.error('Disconnect error:', e);
      setIsDisconnecting(false);
      setError('Failed to disconnect. Please try again.');
    }
  };

  return (
    <div
      style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        zIndex: 9999, padding: '20px',
      }}
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div style={{
        background: '#fff', borderRadius: '16px', padding: '32px',
        maxWidth: '520px', width: '100%',
        boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
      }}>
        {/* Icon */}
        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
          <div style={{
            width: '56px', height: '56px', borderRadius: '50%',
            background: '#fef2f2', display: 'inline-flex',
            alignItems: 'center', justifyContent: 'center', fontSize: '24px',
          }}>
            🔌
          </div>
        </div>

        {/* Title */}
        <h2 style={{ margin: '0 0 10px', textAlign: 'center', fontSize: '20px', fontWeight: 700, color: '#111' }}>
          Disconnect {providerLabel} Calendar?
        </h2>
        <p style={{ margin: '0 0 24px', textAlign: 'center', fontSize: '14px', color: '#555', lineHeight: 1.6 }}>
          SmartClose will no longer sync tasks and deadlines to your {providerLabel} calendar.
          You can reconnect at any time.
        </p>

        {/* Provider badge */}
        <div style={{
          display: 'flex', alignItems: 'center', gap: '8px',
          background: '#f8f9fa', borderRadius: '10px', padding: '12px 16px',
          marginBottom: '24px', border: '1px solid #e9ecef',
        }}>
          <div style={{
            width: '10px', height: '10px', borderRadius: '50%', background: providerColor, flexShrink: 0,
          }} />
          <span style={{ fontSize: '14px', color: '#333', fontWeight: 500 }}>
            Currently connected: <strong>{providerLabel} Calendar</strong>
          </span>
        </div>

        {/* Buttons */}
        <div style={{ display: 'flex', gap: '10px' }}>
          <button
            onClick={onClose}
            disabled={isDisconnecting}
            style={{
              flex: 1, padding: '12px', borderRadius: '8px',
              border: '1px solid #ddd', background: '#fff',
              color: '#333', cursor: isDisconnecting ? 'not-allowed' : 'pointer',
              fontSize: '14px', fontWeight: 500,
              transition: 'all 0.2s ease',
            }}
            onMouseEnter={(e) => { if (!isDisconnecting) e.currentTarget.style.background = '#f5f5f5'; }}
            onMouseLeave={(e) => { e.currentTarget.style.background = '#fff'; }}
          >
            Cancel
          </button>
          <button
            onClick={handleDisconnect}
            disabled={isDisconnecting}
            style={{
              flex: 1, padding: '12px', borderRadius: '8px',
              border: 'none', background: isDisconnecting ? '#aaa' : '#dc2626',
              color: '#fff', cursor: isDisconnecting ? 'not-allowed' : 'pointer',
              fontSize: '14px', fontWeight: 600,
              transition: 'all 0.2s ease',
            }}
            onMouseEnter={(e) => { if (!isDisconnecting) e.currentTarget.style.background = '#b91c1c'; }}
            onMouseLeave={(e) => { if (!isDisconnecting) e.currentTarget.style.background = '#dc2626'; }}
          >
            {isDisconnecting ? 'Disconnecting…' : 'Disconnect Calendar'}
          </button>
        </div>

        {/* Error */}
        {error && (
          <div style={{
            marginTop: '12px', padding: '10px 14px', borderRadius: '8px',
            background: '#fef2f2', border: '1px solid #fca5a5',
            color: '#b91c1c', fontSize: '13px',
          }}>
            {error}
          </div>
        )}
      </div>
    </div>
  );
};

export default CalendarDisconnectModal;
